import React from 'react';
import { DocumentDialog, IDocumentDialogProps } from './DocumentDialog';

export interface IAddDocumentDialogProps extends Omit<IDocumentDialogProps<any>, 'actions'> {}

export class AddDocumentDialog extends React.PureComponent<IAddDocumentDialogProps> {
  constructor(props: IAddDocumentDialogProps) {
    super(props);
  }

  render() {
    return <DocumentDialog actions={['cancel', 'save']} {...this.props} />;
  }
}
